import { useCanAdministerAIAgents } from "~/pages/manifold-nextgen/hooks/useCanAdministerAIAgents";
import { Agent, AgentAccessLevel, AgentScope } from "~/services/agents";

// Avatar customization is an owner-only slice of `can_edit`. It is unavailable for
// SYSTEM agents regardless of access level — their configuration is immutable via
// HTTP, so their avatars stay consistent across every customer instance, even for
// an `admin:agents` caller. Otherwise an admin can customize any CUSTOMER agent
// via the FGA bypass.
export const useCanCustomizeAgentAppearance = (agent: Agent | undefined): boolean => {
  const isAdmin = useCanAdministerAIAgents();
  return (
    !!agent &&
    agent.scope !== AgentScope.SYSTEM &&
    (agent.access_level === AgentAccessLevel.OWNER || isAdmin)
  );
};
